__turbopack_context__.v({
  "linkItem": "mobileNavigationMenu-module-scss-module__fAh7DW__linkItem",
  "panelButtonsSection": "mobileNavigationMenu-module-scss-module__fAh7DW__panelButtonsSection",
});
